import {useState, useMemo} from 'react';

export const useVerificationCode = () => {
  const [verificationCode, setVerificationCode] = useState('');

  const handleCodeChange = (value: string) => {
    const formatted = value.replace(/\D/g, '').slice(0, 6);
    const parts = formatted.match(/./g) || [];
    setVerificationCode(parts.join(' '));
  };

  const cleanCode = useMemo(() => verificationCode.replace(/\s/g, ''), [verificationCode]);
  const isValidCode = useMemo(() => cleanCode.length === 6, [cleanCode]);

  return {
    verificationCode,
    handleCodeChange,
    cleanCode,
    isValidCode,
  };
};
